(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prismicio_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4776);
/* harmony import */ var _prismicio_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9756);
/* harmony import */ var _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7046);
/* harmony import */ var src_components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1128);
/* harmony import */ var src_components_Bounded__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2236);
/* harmony import */ var src_components_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1839);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2962);
/* harmony import */ var src_utils_getExcerpt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3042);










const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
    month: "short",
    day: "numeric",
    year: "numeric"
});
const findFirstImage = (slices)=>{
    const imageSlice = slices.find((slice)=>slice.slice_type === "image");
    if (imageSlice && _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isFilled.image */ .vd.image(imageSlice.primary.image)) {
        return imageSlice.primary.image;
    }
};
const Article = (param)=>{
    let { article  } = param;
    const featuredImage = _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isFilled.image */ .vd.image(article.data.featuredImage) && article.data.featuredImage || findFirstImage(article.data.slices);
    const date = _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .asDate */ .qF(article.data.publishDate || article.first_publication_date);
    const excerpt = (0,src_utils_getExcerpt__WEBPACK_IMPORTED_MODULE_7__/* .getExcerpt */ .L)(article.data.slices);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "grid grid-cols-1 items-start gap-6 md:grid-cols-3 md:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_8__/* .PrismicLink */ .wK, {
                document: article,
                tabIndex: "-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "aspect-w-4 aspect-h-3 relative bg-gray-100",
                    children: _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isFilled.image */ .vd.image(featuredImage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_next__WEBPACK_IMPORTED_MODULE_9__/* .PrismicNextImage */ .Z, {
                        field: featuredImage,
                        fill: true,
                        className: "object-cover",
                        priority: true
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid grid-cols-1 gap-3 md:col-span-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Heading__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X, {
                        as: "h2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_8__/* .PrismicLink */ .wK, {
                            document: article,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_8__/* .PrismicText */ .Kv, {
                                field: article.data.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "font-serif italic tracking-tighter text-slate-500 dark:text-[#f5f4f5]",
                        children: dateFormatter.format(date)
                    }),
                    excerpt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "font-serif leading-relaxed dark:text-[#f5f4f5] md:text-lg md:leading-relaxed",
                        children: excerpt
                    })
                ]
            })
        ]
    });
};
const Index = (param)=>{
    let { articles , navigation , settings  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .A, {
        withHeaderDivider: false,
        navigation: navigation,
        settings: settings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .asText */ .Sz(settings.data.name)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "pt_BR"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, {
                title: _prismicio_helpers__WEBPACK_IMPORTED_MODULE_6__/* .asText */ .Sz(settings.data.name),
                description: "Ariel Franco - Desenvolvedor Front-end - Blog",
                canonical: "https://blog.arielfranco.dev",
                languageAlternates: [
                    {
                        hrefLang: "pt-br",
                        href: "https://blog.arielfranco.dev"
                    }
                ],
                openGraph: [
                    {
                        url: "https://blog.arielfranco.dev",
                        title: "Ariel Franco - Desenvolvedor Front-end - Blog",
                        description: "Ariel Franco - Desenvolvedor Front-end - Blog",
                        images: [
                            {
                                url: settings.data.profilePicture.url
                            }
                        ]
                    }
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Bounded__WEBPACK_IMPORTED_MODULE_3__/* .Bounded */ .g, {
                size: "widest",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "grid grid-cols-1 gap-16",
                    children: articles.map((article)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Article, {
                            article: article
                        }, article.id))
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [617,756,67,128,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);